.hint {
  margin-bottom: var(--sp-4);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-sm);
}

.table th {
  padding: var(--sp-2) var(--sp-3);
  text-align: left;
  color: var(--text-2);
  font-weight: 500;
  border-bottom: 1px solid var(--border);
}

.table td {
  padding: var(--sp-3);
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

.symbolInput {
  width: 6ch;
}

/* Ширина под самую длинную подпись вида "GBP — Фунт стерлингов (£)". */
.currencySelect {
  min-width: 26ch;
}

.rateInput {
  width: 12ch;
}

.addRow {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: var(--sp-4);
  margin-top: var(--sp-5);
}

.addField {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}
